import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from '@/i18n'
import '@/assets/styles/reset.css'
import '@/assets/styles/variables.less'

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')